import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterContainerSectionOption from './VeltCommentsSidebarV2FilterContainerSectionOption/VeltCommentsSidebarV2FilterContainerSectionOption';
var VeltCommentsSidebarV2FilterContainerSectionOptionList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-container-v2-section-option-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterContainerSectionOptionList.Option = VeltCommentsSidebarV2FilterContainerSectionOption;
export default VeltCommentsSidebarV2FilterContainerSectionOptionList;
